import { Button, Tooltip } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { PlanType } from 'api/models';
import { usePackage } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router-dom';
import { isNullish } from 'remeda';
import { useLoadRecoveryPlans } from '../api';

type NewPlanButtonProps = {
  path: string;
  disabledReason: string | null;
};

const NewPlanButton = ({ path, disabledReason }: NewPlanButtonProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const canCreate = isNullish(disabledReason);

  return (
    <Tooltip label={disabledReason} disabled={canCreate}>
      <Button
        leftSection={<IconPlus size={16} stroke={1.5} />}
        data-disabled={!canCreate || undefined}
        onClick={canCreate ? () => history.push(path) : undefined}
      >
        {t(i18nKeys.NEW)}
      </Button>
    </Tooltip>
  );
};

export const NewRecoveryPlanButton = () => {
  const { t } = useTranslation();
  const { recoveryPlans = [] } = useLoadRecoveryPlans();
  const includedPlanCount = usePackage().included_plan_count ?? 0;

  const canCreate = recoveryPlans.length < includedPlanCount;

  return (
    <NewPlanButton
      path="/settings/workflows/recovery-plans/create"
      disabledReason={canCreate ? null : t(i18nKeys.SETTINGS.WORKFLOWS.PLAN_LIMIT_REACHED)}
    />
  );
};

export const NewPaymentWorkflowButton = () => {
  const { t } = useTranslation();
  const { can_use_payment_plans, can_use_advanced_payment_plans } = usePackage();

  const canCreate = can_use_payment_plans && can_use_advanced_payment_plans;

  return (
    <NewPlanButton
      path={`/settings/workflows/${PlanType.payment}/create`}
      disabledReason={canCreate ? null : t(i18nKeys.NOT_INCLUDED)}
    />
  );
};
